import { RootState } from '..';

export const loginCompanySelect = (state: RootState) => state.auth.company;
export const loginBranchSelect = (state: RootState) => state.auth.branch;
export const loginUserIdSelect = (state: RootState) => state.auth.userId;
